document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".grid-view-item .variant-swatch").forEach(function (swatch) {
        swatch.addEventListener("click", function () {
            let variantImage = this.getAttribute("data-variant-image");
            let gridItem = this.closest(".grid-view-item");
            let imageElement = gridItem.querySelector(".grid-view-item__image_front");

            if (variantImage && imageElement.src !== variantImage) {
                // Add fade-out effect
                imageElement.style.opacity = "0";

                // Wait for fade-out to complete before changing the image
                setTimeout(() => {
                    imageElement.src = variantImage;
                    imageElement.setAttribute("srcset", variantImage);

                    // Add fade-in effect
                    imageElement.style.opacity = "1";
                }, 100); // Adjust time to match CSS transition
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
 const dropdowns = document.querySelectorAll(".weglot-dropdown, .topbar-dropdown");

  dropdowns.forEach(dropdown => {
    const toggle = dropdown.querySelector(".dropdown-toggle");
    const menu = dropdown.querySelector(".dropdown-menu");

    toggle.addEventListener("click", function (e) {
      e.stopPropagation();

      // Close all others
      document.querySelectorAll(".dropdown-menu").forEach(m => {
        if (m !== menu) m.classList.remove("show");
      });

      menu.classList.toggle("show");
    });
  });

  // Close on outside click
  document.addEventListener("click", function () {
    document.querySelectorAll(".dropdown-menu").forEach(menu => {
      menu.classList.remove("show");
    });
  });
});


// document.addEventListener("DOMContentLoaded", function() {
//   document.body.style.transform = "scale(0.8)";
//   document.body.style.transformOrigin = "0 0";
//   document.body.style.width = "125%";
// });